export default "__VITE_ASSET__SvMPudiN__"